import { ReactNode } from 'react';
import styles from './Post.module.css';

type PostTextProps = {
  children: ReactNode;
};

const PostText = (props: PostTextProps) => {
  return <div className={`${styles.superTextMedium} ${styles.unselectable}`}>{props.children}</div>;
};

export default PostText;
